﻿import { Routes } from '@angular/router';

import { HomeComponent } from './public/home';
import { LoginComponent, ChangePasswordComponent, SocialComponent } from './public/login';
import { RegisterComponent } from './public/register';
import { UserGuard, RootGuard } from './_guards';
import { RestComponent } from './root/rest';
import { UsersComponent, EditUserComponent } from './root/users';
import { CrearComponent } from './user/crear/crear.component';
import { RootProductoComponent } from './root/producto/producto.component';
import { ListasComponent } from './user/listas/listas.component';
import { RecibirComponent } from './public/recibir/recibir.component';
import { DetalleComponent } from './user/listas/detalle.component';
import { EmpezarComponent } from './public/regalar/empezar.component';
import { RegalarComponent } from './public/regalar/regalar.component';
import { ListaRegalosComponent } from './public/regalar/lista.regalos.component';
import { ResumenRegalosComponent } from './public/regalar/resumen.regalos.component';
import { RootListaComponent } from './root/lista/lista.component';
import { GraciasComponent } from './user/gracias/gracias.component';
import { PublicGraciasComponent } from './public/regalar/gracias.component';
import { RootParametrosComponent } from './root/parametros/parametros.component';
import { AnonimaComponent } from './public/anonima/anonima.component';
import { NuevoProductoComponent } from './root/producto/nuevo.component';
import { PublicFailureComponent } from './public/regalar/failure.component';
import { PublicPendienteComponent } from './public/regalar/pendiente.component';
import { RootPedidoComponent } from './root/lista/pedido.component';


export const appRoutes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'change', component: ChangePasswordComponent },
    { path: 'oauth', component: SocialComponent },
    { path: 'home', component: HomeComponent },
    { path: 'recibir', component: RecibirComponent },
    { path: 'regalar', component: RegalarComponent},
    { path: 'empezar', component: EmpezarComponent},
    { path: 'gracias', component: PublicGraciasComponent },
    { path: 'failure', component: PublicFailureComponent },
    { path: 'pendiente', component: PublicPendienteComponent },
    { path: 'regalo', component: AnonimaComponent },
    { path: 'elegir', component: ListaRegalosComponent },
    { path: 'resumen', component: ResumenRegalosComponent },
    { path: 'user', canActivateChild: [UserGuard],
        children: [            
            { path: 'crear', component: CrearComponent },
            { path: 'lista', children: [
                { path: '', component: ListasComponent },
                { path: ':id', component: DetalleComponent }
                ]
            },
            { path: 'gracias', children: [
                { path: ':id', component: GraciasComponent }
                ]
            }
        ]
    },
    { path: 'root', canActivateChild: [RootGuard],
        children: [
            { path: 'rest', component: RestComponent },
            { path: 'producto', component: RootProductoComponent },
            { path: 'lista', component: RootListaComponent },
            { path: 'pedido', component: RootPedidoComponent },
            { path: 'parametros', component: RootParametrosComponent },
            { path: 'nuevoProducto', component: NuevoProductoComponent },
            { path: 'users', children: [
                    { path: '', component: UsersComponent },
                    { path: ':id', component: EditUserComponent }
                ]
            }

        ]
    },
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: '**', redirectTo: '' }

];
